import React, { ReactNode } from "react";
import { Permission } from "../common/constants/permissions";

export interface IApp {
  icon: string;
  name: string;
  id: string;
  description: string;
  launchUrl: string;
  tags?: string[];
  bookmarked: boolean;
  isBeta: boolean;
  isFindemApp: boolean;
  // for apps hosted on front-door itself without iframe
  isCSR?: boolean;
  component?: ReactNode | React.FC;
  permission?: Permission;
}

export const APP_NAMES = {
  ESP: 'esp',
  RRA: 'rra'
} as const;

export type AppName = typeof APP_NAMES[keyof typeof APP_NAMES];